import { FlatItem, ApiFlatItem } from "../../types/general";
import { navigateTo } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";

export const mapApiFlatData = (payload: ApiFlatItem): FlatItem => ({
  id: payload?.id || payload?.ID,
  name: payload.name || payload.NAME,
});

export const nextStepRedirect = (step) => {
  const parsed = queryString.parse(window.location.search);
  navigateTo(
    `/${RouteNames.ADD_WARRNTY_ITEM}?${queryString.stringify({
      ...parsed,
      step,
    })}`
  );
};
